/* Prime Cuts — reveal on scroll.
   Load once in theme.liquid:  <script src="{{ 'pc-global.js' | asset_url }}" defer></script>
   Adds the `in` class to any `.reveal` element as it enters the viewport. */
(function () {
  function initReveals(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var revealables = scope.querySelectorAll('.reveal:not([data-reveal-bound])');
    if (!revealables.length) return;

    if (!('IntersectionObserver' in window)) {
      revealables.forEach(function (el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    revealables.forEach(function (el) {
      el.setAttribute('data-reveal-bound', '');
      io.observe(el);
    });
  }

  function boot() {
    initReveals(document);
  }

  // Run now if the DOM is already parsed (true for deferred scripts),
  // otherwise wait for it. This avoids missing a DOMContentLoaded that
  // already fired before this script attached its listener.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Safety net: re-scan after full load in case sections streamed in late.
  window.addEventListener('load', function () { initReveals(document); });

  // Re-scan when sections are added/edited in the theme editor.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { initReveals(e.target); });
  }
})();